// Macros = resposta rápida + ações feitas DEPOIS que a mensagem é enviada
// (modelo Zendesk/Intercom). O backend só guarda (QuickReply.actions); quem
// executa é o Atendimento, pelos mesmos fluxos dos botões, nesta ordem:
// assumir → concluir a solicitação → encaminhar → encerrar.

export type MacroAction =
  | { type: 'assign_me' }
  | { type: 'resolve_request' }
  | { type: 'forward_sector'; sector_key: string }
  | { type: 'close_session' };

export type MacroActionType = MacroAction['type'];

export const MACRO_ACTION_ORDER: MacroActionType[] = ['assign_me', 'resolve_request', 'forward_sector', 'close_session'];

export const MACRO_ACTION_LABELS: Record<MacroActionType, string> = {
  assign_me: 'Assumir o atendimento',
  resolve_request: 'Concluir a solicitação aberta',
  forward_sector: 'Encaminhar para um setor',
  close_session: 'Encerrar o atendimento',
};

/** Rótulo curto para listas ("conclui · encerra"). */
const SHORT: Record<MacroActionType, string> = {
  assign_me: 'assume',
  resolve_request: 'conclui',
  forward_sector: 'encaminha',
  close_session: 'encerra',
};

export function sortMacroActions(actions: MacroAction[]): MacroAction[] {
  return [...actions].sort((a, b) => MACRO_ACTION_ORDER.indexOf(a.type) - MACRO_ACTION_ORDER.indexOf(b.type));
}

export function describeMacroActions(actions: MacroAction[] | undefined): string {
  if (!actions || actions.length === 0) return '';
  return `responde + ${sortMacroActions(actions).map((a) => SHORT[a.type]).join(' + ')}`;
}

export function describeMacroActionsLong(actions: MacroAction[], sectorName?: (key: string) => string): string[] {
  return sortMacroActions(actions).map((a) =>
    a.type === 'forward_sector'
      ? `Encaminhar para ${sectorName?.(a.sector_key) ?? a.sector_key}`
      : MACRO_ACTION_LABELS[a.type]);
}
